import { ReactNode } from 'react';

import { CheckmarkIcon } from '@/ui/Icons/CheckmarkIcon';

import { fontStyles } from '../../../styles/typography';

export const StyledH2 = ({ className, children }: { className?: string; children: ReactNode }) => (
  <h2 className={fontStyles({ variant: 'H2', class: `mb-4 grid ${className}` })}>{children}</h2>
);

export const StyledParagraph = ({
  children,
  className,
}: {
  children: React.ReactNode;
  className?: string;
}) => (
  <p className={fontStyles({ variant: 'BODY_LG', class: `text-token-gray-800 ${className}` })}>
    {children}
  </p>
);

export const StyledPrimaryCell = ({
  className,
  children,
  style,
}: {
  className?: string;
  style?: React.CSSProperties;
  children: ReactNode;
}) => (
  <section
    className={`border border-token-gray-300 border-solid overflow-hidden rounded-lg pt-11 tablet:pt-15 px-11 tablet:px-15 w-full mx-auto mb-5 bg-token-gray-100 flex justify-center max-w-[1240px] ${className}`}
    style={style}
  >
    {children}
  </section>
);

export const StyledSecondaryCell = ({
  className,
  children,
}: {
  className?: string;
  children: ReactNode;
}) => (
  <div
    className={`bg-primitive-basic-white rounded-t-[20px] ${className}`}
    style={{
      border: '1px solid #E5E7EB',
      borderBottom: 'none',
      boxShadow:
        '0px 1.71681px 3.43363px 0px rgba(0, 0, 0, 0.02), 0px 17.16814px 60.0885px 0px rgba(0, 0, 0, 0.06), 0px 1.71681px 10.30089px 0px rgba(0, 0, 0, 0.03)',
    }}
  >
    {children}
  </div>
);

export const CheckMarkList = ({ items }: { items: string[] }) => (
  <ul className="text-token-gray-600 mt-1">
    {items.map((text) => (
      <li className="flex items-center mt-4 first:mt-0" key={text}>
        <div
          className="flex items-center self-start rounded-full text-primitive-basic-white justify-center h-6 w-6 flex-shrink-0"
          style={{
            background:
              'linear-gradient(308.48deg, #02A863 -13.93%, rgba(2, 168, 99, 0.49) 112.7%)',
            boxShadow: '0px 1px 3px rgba(0, 0, 0, 0.12), inset 0px -1px 0px rgba(0, 0, 0, 0.16)',
          }}
        >
          <CheckmarkIcon />
        </div>
        <span
          className={fontStyles({
            variant: 'BODY_LG',
            class: 'ml-3 text-token-gray-800 font-normal',
          })}
        >
          {text}
        </span>
      </li>
    ))}
  </ul>
);
